import { combineReducers } from "redux";
import { messageReducer } from "./message/reducer";
import { userReducer } from "./user/reducer";

const rootReducer = combineReducers({
    user: userReducer,
    message: messageReducer,
})

export default rootReducer;